import React from 'react'
import { CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { LuDownload } from 'react-icons/lu'
import { AI_TOOL_LOADING_SIZES } from './aiToolLoadingSizes'

const downloadPdfButtonSx = {
  background: 'var(--gold-gradient)',
  color: 'var(--text-on-primary)',
  fontFamily: "'Anton', sans-serif",
  fontSize: 11,
  letterSpacing: '2px',
  textTransform: 'uppercase',
  fontWeight: 400,
  px: 2.25,
  py: 1.125,
  borderRadius: '7px',
  lineHeight: 1.2,
  '& .MuiButton-startIcon': {
    marginRight: '8px',
    marginLeft: 0,
  },
  '& .MuiLoadingButton-startIconLoadingIndicator': {
    marginRight: '8px',
    marginLeft: 0,
  },
  '&:hover': {
    background: 'var(--gold-gradient)',
    opacity: 0.9,
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    color: 'var(--text-on-primary)',
    background: 'var(--gold-gradient)',
  },
}

function AiToolDownloadPdfButton({
  loading = false,
  onClick,
  children = 'Download PDF',
  disabled,
  sx,
}) {
  return (
    <LoadingButton
      type="button"
      variant="contained"
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      loadingPosition="start"
      startIcon={
        <LuDownload aria-hidden className="ai-tool-download-pdf-icon" />
      }
      loadingIndicator={
        <CircularProgress
          color="inherit"
          size={AI_TOOL_LOADING_SIZES.compact}
        />
      }
      disableElevation
      sx={{
        ...downloadPdfButtonSx,
        ...sx,
      }}
    >
      {children}
    </LoadingButton>
  )
}

export default AiToolDownloadPdfButton
